/** Home hero slideshow — Admin → Site → Content → Home hero */

export const HOME_HERO_SLIDES_MAX = 8;

export const HOME_HERO_LAYOUT_DEFAULT = 'split';

export const HOME_HERO_AUTOPLAY_DEFAULT_SEC = 6;

export const HOME_HERO_SLIDE_DEFAULT = {
  enabled: true,
  image: '',
  alt: '',
  link: '/shop',
  focal_x: 50,
  focal_y: 28,
};
